<form
  #addressForm="ngForm"
  (ngSubmit)="submit(addressForm)"
  novalidate>
  <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
    <div
      *ngIf="address.addressType !== userAddressType.Main"
      class="row">
      <div class="col-12">

        <div class="mb-3">
          <label class="form-label" for="type">
            Address type
          </label>
          <select
            #type="ngModel"
            class="form-control form-select"
            [class.is-invalid]="type.touched && !type.valid"
            id="type"
            name="type"
            [(ngModel)]="address.addressType"
            placeholder="Address type"
            required>
            <option *ngIf="!type.value" disabled selected [ngValue]="null">
              -- Please select --
            </option>
            <option *ngFor="let addressType of selectableAddressTypes" [ngValue]="addressType.value">
              {{ addressType.name }}
            </option>
          </select>
          <div
            *ngIf="type.invalid && type.errors.required"
            class="invalid-feedback">
            {{ errorStrings.required }}
          </div>
        </div>

        <div class="mb-3 d-flex justify-content-center mt-4">
          <div class="btn-group btn-group-toggle">
            <button
              type="button"
              class="btn btn-outline-dark"
              [ngClass]="{'active': !address.temporary}"
              (click)="address.temporary = null">
              Permanent
            </button>
            <button
              type="button"
              class="btn btn-outline-dark"
              [ngClass]="{'active': address.temporary}"
              (click)="address.temporary = { dateStart: null, dateEnd: null }">
              Temporary
            </button>
          </div>
        </div>

        <div *ngIf="address.temporary" class="row">

          <div class="col-xs-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="startDate">
                Start date
              </label>
              <div class="input-group">
                <input
                  #dateStart="ngbDatepicker"
                  #dateStartModel="ngModel"
                  class="form-control"
                  [class.is-invalid]="dateStartModel.touched && dateStartModel.invalid"
                  name="startDate"
                  [(ngModel)]="fromDate"
                  placeholder="dd/mm/yyyy"
                  ngbDatepicker
                  [minDate]="minDate"
                  [appIsDateBefore]="toDate"
                  (ngModelChange)="updateValueAndValidity(addressForm.controls['endDate'])"
                  required>
                  <button
                    class="btn btn-outline-dark calendar"
                    (click)="dateStart.toggle()"
                    type="button">
                    <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                  </button>
                <div
                  *ngIf="dateStartModel.invalid && dateStartModel.errors.required"
                  class="invalid-feedback">
                  {{ errorStrings.required }}
                </div>
                <div
                  *ngIf="dateStartModel.invalid &&
                        dateStartModel.errors.ngbDate &&
                        dateStartModel.errors.ngbDate.invalid"
                  class="invalid-feedback">
                  {{ errorStrings.invalidDateForm }}
                </div>
                <div
                  *ngIf="dateStartModel.invalid &&
                        dateStartModel.errors.ngbDate &&
                        dateStartModel.errors.ngbDate.minDate"
                  class="invalid-feedback">
                  Please enter a date after
                  {{ dateStartModel.errors.ngbDate.minDate.minDate.day + '/' +
                    dateStartModel.errors.ngbDate.minDate.minDate.month + '/' +
                    dateStartModel.errors.ngbDate.minDate.minDate.year }}.
                </div>
                <div
                  *ngIf="dateStartModel.invalid &&
                        dateStartModel.errors.isDateBeforeAfter &&
                        dateStartModel.errors.isDateBeforeAfter.value === 'before'"
                  class="invalid-feedback">
                  {{ errorStrings.invalidStartDateRange }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6">
            <div class="mb-3">
              <label class="form-label" for="endDate">
                End date
              </label>
              <div class="input-group">
                <input
                  #dateEnd="ngbDatepicker"
                  #dateEndModel="ngModel"
                  class="form-control"
                  [class.is-invalid]="dateEndModel.touched && dateEndModel.invalid"
                  name="endDate"
                  [(ngModel)]="toDate"
                  placeholder="dd/mm/yyyy"
                  ngbDatepicker
                  [minDate]="minDate"
                  [appIsDateAfter]="fromDate"
                  (ngModelChange)="updateValueAndValidity(addressForm.controls['startDate'])"
                  required>
                  <button
                    class="btn btn-outline-dark calendar"
                    (click)="dateEnd.toggle()"
                    type="button">
                    <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                  </button>
                <div
                  *ngIf="dateEndModel.invalid && dateEndModel.errors.required"
                  class="invalid-feedback">
                  {{ errorStrings.required }}
                </div>
                <div
                  *ngIf="dateEndModel.invalid &&
                        dateEndModel.errors.ngbDate &&
                        dateEndModel.errors.ngbDate.invalid"
                  class="invalid-feedback">
                  {{ errorStrings.invalidDateForm }}
                </div>
                <div
                  *ngIf="dateEndModel.invalid &&
                        dateEndModel.errors.ngbDate &&
                        dateEndModel.errors.ngbDate.minDate"
                  class="invalid-feedback">
                  Please enter a date after
                  {{ dateEndModel.errors.ngbDate.minDate.minDate.day + '/' +
                    dateEndModel.errors.ngbDate.minDate.minDate.month + '/' +
                    dateEndModel.errors.ngbDate.minDate.minDate.year }}.
                </div>
                <div
                  *ngIf="dateEndModel.invalid &&
                        dateEndModel.errors.isDateBeforeAfter &&
                        dateEndModel.errors.isDateBeforeAfter.value === 'after'"
                  class="invalid-feedback">
                  {{ errorStrings.invalidEndDateRange }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="fullForm"
      class="mb-3">
      <label class="form-label" for="line1">
        Address line 1
      </label>
      <input
        #line1="ngModel"
        class="form-control"
        [class.is-invalid]="line1.touched && !line1.valid"
        id="line1"
        name="line1"
        [(ngModel)]="address.line1"
        placeholder="Address line 1"
        required
        type="text">
      <div
        *ngIf="line1.invalid && line1.errors.required"
        class="invalid-feedback">
        {{ errorStrings.required }}
      </div>
    </div>

    <div
      *ngIf="fullForm"
      class="mb-3">
      <label class="form-label" for="line2">
        Address line 2 (optional)
      </label>
      <input
        #line2="ngModel"
        class="form-control"
        [class.is-invalid]="line2.touched && !line2.valid"
        id="line2"
        name="line2"
        [(ngModel)]="address.line2"
        placeholder="Address line 2"
        type="text">
    </div>

    <div
      *ngIf="fullForm"
      class="mb-3">
      <label class="form-label" for="city">
        Town/City
      </label>
      <input
        #city="ngModel"
        class="form-control"
        [class.is-invalid]="city.touched && !city.valid"
        id="city"
        name="city"
        [(ngModel)]="address.town"
        placeholder="Town/City"
        required
        type="text">
      <div
        *ngIf="city.invalid && city.errors.required"
        class="invalid-feedback">
        {{ errorStrings.required }}
      </div>
    </div>

    <div
      *ngIf="fullForm"
      class="mb-3">
      <label class="form-label" for="county">
        County (optional)
      </label>
      <input
        #county="ngModel"
        class="form-control"
        [class.is-invalid]="county.touched && !county.valid"
        id="county"
        name="county"
        [(ngModel)]="address.county"
        placeholder="County"
        type="text">
    </div>

    <div class="mb-3">
      <label class="form-label" for="postcode">
        Postcode
      </label>
      <input
        #postcode="ngModel"
        class="form-control"
        [class.is-invalid]="(postcode.touched && !postcode.valid) || postcodeNotFound"
        id="postcode"
        name="postcode"
        [(ngModel)]="address.postcode"
        (ngModelChange)="postcodeNotFound = false"
        placeholder="Postcode"
        required
        type="text">
      <div
        *ngIf="postcode.errors && postcode.errors.required"
        class="invalid-feedback">
        {{ errorStrings.required }}
      </div>
      <div *ngIf="postcodeNotFound"
          class="invalid-feedback">
        Unable to find an address
      </div>
    </div>

    <div *ngIf="!fullForm && foundAddresses.length"
        class="mb-3">
      <label for="addressSelector" class="form-label visually-hidden">
        Select Address
      </label>
      <select
        #addressSelector="ngModel"
        class="form-control form-select"
        id="addressSelector"
        name="addressSelector"
        [(ngModel)]="selectedAddress"
        (ngModelChange)="onAddressSelect($event)"
        [disabled]="postcodeFinderLoading">
        <option *ngIf="!selectedAddress" disabled selected [ngValue]="null">
          -- Please select --
        </option>
        <option *ngFor="let address of foundAddresses" [ngValue]="address">
          {{ addressFinder.getAddressLines(address).join(', ') }}
        </option>
      </select>
    </div>

    <div class="row">
      <div *ngIf="!fullForm"
          class="col-xs-12 col-sm-6">
        <button
          class="btn btn-primary w-100"
          (click)="findAddress(postcode.value)"
          [disabled]="!postcode.value || postcodeFinderLoading"
          type="button">
          <fa-icon *ngIf="postcodeFinderLoading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
          {{ postcodeFinderLoading ? 'Looking...' : 'Find address' }}
        </button>
      </div>
      <div *ngIf="!fullForm"
          class="col-xs-12 col-sm-6 mt-3 mt-sm-0">
        <button
          class="btn btn-dark w-100"
          (click)="openFullForm()"
          type="button"
          [disabled]="postcodeFinderLoading">
          Enter manually
        </button>
      </div>
      <div *ngIf="fullForm"
          class="col-xs-12 offset-sm-6 col-sm-6">
        <button class="btn btn-dark w-100"
                (click)="closeFullForm()"
                type="button">
          Look up address
        </button>
      </div>
    </div>

    <div *ngIf="address.temporary">
      <div class="mb-3 mt-3">
        <label class="form-label" for="contactname">
          Contact Person (optional)
        </label>
        <input
          #contactname="ngModel"
          class="form-control"
          id="contactname"
          name="contactname"
          [(ngModel)]="address.temporaryContactName"
          placeholder="Contact Person"
          type="text">
      </div>
      <div>
        <label class="form-label" for="contactnumber">
          Contact Number (optional)
        </label>
        <input
          #contactnumber="ngModel"
          class="form-control"
          [class.is-invalid]="contactnumber.touched && !contactnumber.valid"
          id="contactnumber"
          name="contactnumber"
          [(ngModel)]="address.temporaryPhoneNumber"
          [pattern]="validationPatterns.telephone"
          placeholder="Phone number"
          type="text">
        <div
          *ngIf="contactnumber.errors && contactnumber.errors.pattern && !contactnumber.errors.minlength"
          class="invalid-feedback">
          {{ errorStrings.telephoneInvalid }}
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <button
      *ngIf="showButton"
      type="submit"
      class="btn btn-success text-white btn-lg mt-5"
      [ngClass]="useRebrandedLayout ? 'w-75' : 'w-100'"
      [disabled]="!addressForm.valid ||
                  !fullForm ||
                  showLoader">
      <fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
      {{ showLoader ? 'Saving' : 'Save' }}
    </button>
  </div>

</form>
